import { useLocation } from 'react-router';
import { HandleStartGameSession } from './types';
import { useMemo } from 'react';
import { excludedPages } from './helpers';
import { FIVE_SECONDS, THREE_SECONDS } from 'src/constants';

export const handlePlayMusic = (audioElement: HTMLAudioElement | null) => {
  if (audioElement) {
    audioElement.play();
  }
};

export const handleStopMusic = (audioElement: HTMLAudioElement | null) => {
  if (audioElement) {
    audioElement.pause();
    audioElement.currentTime = 0;
  }
};

export const handleStartGameSession: HandleStartGameSession = ({
  setIsGameSessionActive,
  setActiveModal,
  setShowGameRules,
  setIsUserCurrentlyPlaying
}) => {
  setActiveModal(null);
  setIsGameSessionActive(true);
  setShowGameRules(true);

  setTimeout(() => {
    setShowGameRules(false);
  }, THREE_SECONDS);

  setTimeout(() => {
    setIsUserCurrentlyPlaying(true);
  }, FIVE_SECONDS);
};

export const useCheckGamePopUpAvailable = () => {
  const { pathname } = useLocation();
  const isGameBannerAvailable = useMemo(
    () => !excludedPages.some((route) => pathname.includes(route)),
    [pathname]
  );
  return isGameBannerAvailable;
};

export const generatePrizeAmountObject = (
  prodAmount: Record<number, number>,
  defaultValue = 228
) => {
  return Array.from({ length: 31 }, (_, index) => index + 1).reduce<Record<number, number>>(
    (acc, date) => {
      acc[date] = prodAmount[date] ?? defaultValue;
      return acc;
    },
    {}
  );
};

type BonusesIdsTurple = [number, number, number, number, number, number];
export const generateHardcodeBonusesObject = (devBonuses: BonusesIdsTurple) => {
  return Array.from({ length: 31 }, (_, index) => index + 1).reduce<
    Record<number, BonusesIdsTurple>
  >((acc, date) => {
    acc[date] = devBonuses;
    return acc;
  }, {});
};
